import { supabase } from "@/integrations/supabase/client";
import { Event, Booking } from "@/types/events";
import { format } from "date-fns";

interface DashboardStats {
  totalEvents: number;
  totalParticipants: number;
  uniqueNPOs: number;
  upcomingEventsList: Event[];
  recentBookings: Booking[];
}

export const getCorporateDashboardStats = async (access_token: string): Promise<DashboardStats> => {
  try {
    const response = await fetch(`${import.meta.env.VITE_CC_API_URL}/v1/me/dashboard`, {
      headers: {
        'Authorization': `Bearer ${access_token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch dashboard data');
    }

    const { data } = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    return {
      totalEvents: 0,
      totalParticipants: 0,
      uniqueNPOs: 0,
      upcomingEventsList: [],
      recentBookings: [],
    };
  }
};
